import { createElement, useCallback, useState } from 'react'
import { useProjectMutations } from '@/components/AppShell/useProjectMutations.js'
import NewProjectDialog from './NewProjectDialog.jsx'

export function useProjectActions({ setActiveProjectId }) {
  const [dialogOpen, setDialogOpen] = useState(false)
  const mutations = useProjectMutations({
    onProjectCreated: (project) => setActiveProjectId(project.id),
  })

  const handleNewProject = useCallback(() => setDialogOpen(true), [])
  const handleProjectSelect = useCallback(
    (project) => setActiveProjectId(project?.id ?? null),
    [setActiveProjectId],
  )
  const handleRenameProject = useCallback(
    (project, name) => mutations.updateProject.mutate({ id: project.id, patch: { name } }),
    [mutations.updateProject],
  )
  const handleCreateProject = useCallback(
    (values) => mutations.createProject.mutate(values),
    [mutations.createProject],
  )
  const projectDialog = createElement(NewProjectDialog, {
    open: dialogOpen,
    onClose: () => setDialogOpen(false),
    onSubmit: handleCreateProject,
  })

  return {
    projectDialog,
    handleNewProject,
    handleProjectSelect,
    handleRenameProject,
  }
}
